import { graphql } from 'react-relay';
import { getMonitoringClient } from '@confluence/monitoring/entry-points/getMonitoringClient.ts';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { isUnauthorizedError } from '@confluence/error-boundary/entry-points/isUnauthorizedError.ts';
import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled.ts';

import { getIsProductAdminFromQuery } from './getIsProductAdminFromQuery.ts';
import { getIsProductOrSiteAdminFromQuery } from './getIsProductOrSiteAdminFromQuery.ts';
import type { useIsProductAdminUseIsProductAdminQuery as useIsProductAdminUseIsProductAdminQuery$data } from './__types__/useIsProductAdminUseIsProductAdminQuery.ts';
import { useQueryInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop.ts';
export const useIsProductAdmin = (): {
	isProductAdmin: boolean;
	isProductOrSiteAdmin: boolean;
	isAdminCheckLoading: boolean;
} => {
	const {
		data,
		error,
		loading: isAdminCheckLoading,
	} = useQueryInterop<useIsProductAdminUseIsProductAdminQuery$data>(graphql`
		query useIsProductAdminUseIsProductAdminQuery {
			user: confluence_atlassianUser(current: true) {
				id
				confluence {
					operations {
						operation
						targetType
					}
				}
			}
			isSiteAdmin
			hasUserAccessAdminRole
		}
	`);

	if (error) {
		if (!isUnauthorizedError(error)) {
			getMonitoringClient().submitError(error, {
				attribution: Attribution.ADMIN_EXPERIENCE,
			});
		}
		markErrorAsHandled(error);
	}

	const isProductAdmin = getIsProductAdminFromQuery(data);
	const isProductOrSiteAdmin = getIsProductOrSiteAdminFromQuery(data);

	return { isProductAdmin, isProductOrSiteAdmin, isAdminCheckLoading };
};
